"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var variableObj = {
  maxWidth: 'max-width',
  minWidth: 'min-width',
  windowWidth: window.screen.width,
  colon: ':',
  pixel: 'px'
};
var _default = variableObj;
exports["default"] = _default;